import { Button } from "src/@/components/ui/button"
import { Input } from "src/@/components/ui/input"
import { Label } from "src/@/components/ui/label"
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover"
import Scrollbar from "src/components/Scrollbar";

export function Participantes({ chat }) {
    const participantes = chat?.people;
    const participantesSlice = chat.people.slice(0, 4);
    const extra = chat.people.length - 4;
    return (
        <Popover>
            <PopoverTrigger asChild>
            <div className="flex gap-1 items-center m-0.5">
                    {participantesSlice.map((item, index) => {
                        const nome = item.nomeFantasia.length > 15
                            ? item.nomeFantasia.substring(0, 15) + '...'
                            : item.nomeFantasia;

                        return (
                            <div
                                className="bg-violet-100 dark:bg-violet-500/10 dark:text-violet-300 flex items-center justify-center rounded text-[12px] px-2 h-6"
                                key={index}
                            >
                                {nome}
                                {index < participantesSlice.length - 1}
                            </div>
                        );
                    })}
                    {extra > 0 && (
                         <Button className="p-0 m-0 text-sm" variant="text"> +{extra} participantes</Button>
                    )}
                  

                </div>
            </PopoverTrigger>
            <PopoverContent className="w-80">
                <Scrollbar className="max-h-56">

                    <div className="text-[12px] dark:text-[#D1D2D3] flex-col flex gap-1">
                        {
                            participantes.length > 1 && participantes.map((item, index) => {
                                return (
                                    <span className='p-1 rounded px-1 dark:hover:bg-[#2A2A2A]' key={index}>{item.nomeFantasia}{index < participantes.length - 1 && ', '}</span>
                                )
                            })

                        }
                    </div>
                </Scrollbar>
            </PopoverContent>
        </Popover>
    )
}
